import { type JSX } from 'react';
import IconMessage from '@common/components/Messages/IconMessage';
import IconStatusAlert from '@common/components/svgs/status/Alert';
import { type ErrorColor, type WarningColor } from '@common/types/colors';

export interface ErrorMessageProps {
  type?: ErrorColor | WarningColor;
  children: JSX.Element | string;
}

function ErrorMessage({
  type = 'error',
  children,
}: Readonly<ErrorMessageProps>) {
  return (
    <IconMessage
      component={IconStatusAlert}
      color={type}
      title={(
        <span className={`txt-${type}`} data-testid="errorMessageText">
          {children}
        </span>
      )}
    />
  );
}

export default ErrorMessage;
